var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"at-chat",class:{'wpguppy-rtl' : _vm.isRtl}},[_c('guppy-chat-sidebar'),_c('guppy-chat-messages'),_c('sidebar-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }